import initialState from '../store/initialState';

import {
    SET_LOADER_SITES,
    APPROVE_API_REQUEST,
    DELETE_API_REQUEST,
    DENY_API_REQUEST,
    FETCH_SITES,
    FETCH_API_GROUPS,
    CATCH_ERROR_SITES,
    RESET_ACTION_SITES
} from '../actions/type';

const siteReducer = (state = initialState.sites,action) => {
    switch(action.type) {
        case SET_LOADER_SITES:
            return { ...state, isLoading: action.payload }
        case APPROVE_API_REQUEST:
            return { ...state, response: action.payload }
        case DENY_API_REQUEST:
            return { ...state, response: action.payload }
        case DELETE_API_REQUEST:
            return { ...state, response: action.payload }
        case FETCH_SITES:
            return { ...state, siteList: action.payload }
        case FETCH_API_GROUPS:
            return { ...state, apiGroupList: action.payload }
        case CATCH_ERROR_SITES:
            return { ...state, errorResponse: action.payload }
        case RESET_ACTION_SITES:
            return { ...state, errorResponse: [], response: [] }
        default: return state;
    }
}

export default siteReducer;